import { render, staticRenderFns } from "./AppMenuIcon.vue?vue&type=template&id=66da705d&"
import script from "./AppMenuIcon.vue?vue&type=script&lang=js&"
export * from "./AppMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports